// extracted by mini-css-extract-plugin
module.exports = {"menu":"RDSTiNcy","menubox":"qCR_IdSX","backButton":"uSOcUHCf","adPlaceholder":"MSI91bUs","withAd":"jKCXoFDW"};